var map = {
	"./agenda-una-reunion/img-header.webp": 1420,
	"./como-funciona/img-header.webp": 908,
	"./nuestra-propuesta/img-header.webp": 909,
	"./politicas/img-header.webp": 1421,
	"./preguntas-frecuentes/img-header.webp": 1422,
	"./quienes-somos/img-header.webp": 1423,
	"./registro/img-header.webp": 1424,
	"./tratamiento-datos/img-header.webp": 1425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2671;